module.exports = __webpack_public_path__ + "assets/img/es-e41eaf42.png";